var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$store.state.webNavigator == "pc"
      ? _c("div", { staticClass: "homeNews" }, [
          _c("div", { staticClass: "home-news marginAuto max1720" }, [
            _c("div", [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "news-list" },
                _vm._l(_vm.bannerData, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "news-list-bar displayIB" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "news-list-Left displayIB pointEr",
                          on: {
                            click: function($event) {
                              return _vm.gotoPath2(item.bannerDataUrl, index, 0)
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "news-list-img",
                            attrs: {
                              src: _vm.httptype(item.bannerImg),
                              alt: "",
                              title: ""
                            }
                          }),
                          _c(
                            "p",
                            { staticClass: "news-list-LeftText overflowText" },
                            [_vm._v("  " + _vm._s(" ● " + item.bannerImgName))]
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "news-list-Right displayIB" },
                        [
                          _c("p", { staticClass: "news-list-Tlt" }, [
                            _c("span", { staticClass: "news-list-tip" }),
                            _vm._v(_vm._s(item.bannerName))
                          ]),
                          _vm._l(item.bannerList, function(item2, index2) {
                            return _c(
                              "p",
                              {
                                key: index2,
                                staticClass:
                                  "overflowText news-list-RightText pointEr",
                                on: {
                                  click: function($event) {
                                    return _vm.gotoPath2(item2, index, 0)
                                  }
                                }
                              },
                              [_vm._v(_vm._s("● " + item2.articleTitle))]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        ])
      : _c("div", { staticClass: "phone-page" }, [
          _vm._m(1),
          _c(
            "div",
            { staticClass: "news-list" },
            _vm._l(_vm.bannerData, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "news-list-bar displayIB" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "news-list-Left displayIB pointEr positionRE",
                      on: {
                        click: function($event) {
                          return _vm.gotoPath2(item.bannerDataUrl, index, 0)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "news-list-img",
                        attrs: {
                          src: _vm.httptype(item.bannerImg),
                          alt: "",
                          title: ""
                        }
                      }),
                      _c(
                        "p",
                        {
                          staticClass:
                            "news-list-LeftText overflowText positionAB"
                        },
                        [_vm._v("  " + _vm._s("● " + item.bannerImgName))]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "news-list-Right displayIB" },
                    [
                      _c("p", { staticClass: "news-list-Tlt" }, [
                        _c("span", { staticClass: "news-list-tip" }, [
                          _vm._v("| ")
                        ]),
                        _vm._v(_vm._s(item.bannerName))
                      ]),
                      _vm._l(item.bannerList, function(item2, index2) {
                        return index2 > 0 && index2 <= 4
                          ? _c(
                              "p",
                              {
                                key: index2,
                                staticClass:
                                  "overflowText news-list-RightText pointEr",
                                on: {
                                  click: function($event) {
                                    return _vm.gotoPath2(item2, index, 0)
                                  }
                                }
                              },
                              [_vm._v(_vm._s("● " + item2.articleTitle))]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ]
              )
            }),
            0
          )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flexSpace" }, [
      _c("p", { staticClass: "part-title list-tlt displayIB" }, [
        _vm._v("健康瘦身资讯"),
        _c("span", { staticClass: "list-tlt-tip" }, [_vm._v("-")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "PhoneHome-title" }, [
      _vm._v("\n      健康瘦身资讯 "),
      _c("span", { staticClass: "col00CDA2" }, [_vm._v("-")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33076cba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33076cba","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/hometest/comPonents/homeNews/homeNews.vue
// module id = 989
// module chunks = 1